import { render } from "./TaxType.vue?vue&type=template&id=69d5b25e&ts=true"
import script from "./TaxType.vue?vue&type=script&lang=ts"
export * from "./TaxType.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__